export enum ActivationStage {
    UnclaimedByBroker = 'UnclaimedByBroker',
    ClaimUnderVerification = 'ClaimUnderVerification', // (eg: when broker tries claiming his page on Aggregator)
    VerifiedBySmooved = 'VerifiedBySmooved', // (eg: after first demo with Sales, or after Aggregator claim has been approved)
    ActivatedInSmooved = 'ActivatedInSmooved', // (eg: after first move)
    InactivatedInSmooved = 'InactivatedInSmooved', // (eg: 6 months after last activity, eg Dewaele - which we should be able to penalise)
    NonBroker = 'NonBroker', // (eg: Sociaal Verhuurkantoor / OCMW / Relotrust)
}
